import { render, staticRenderFns } from "./Subscribe.vue?vue&type=template&id=afc106ae&scoped=true&"
import script from "./Subscribe.vue?vue&type=script&lang=ts&"
export * from "./Subscribe.vue?vue&type=script&lang=ts&"
import style0 from "./Subscribe.vue?vue&type=style&index=0&id=afc106ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc106ae",
  null
  
)

export default component.exports